<template>
  <div class="element-popup" v-if="status">
    <div class="container">
    <div class="popup-header" style="border-bottom: solid 1px #bbb;">
      {{ label }}
      <p class="close" @click="clickClose()"></p>
    </div>

    <div class="popup-body">

      <div class="section-tab">
        <div class="container">
          <div class="section-tab-header">
            <element-tab>
              <element-tab-item @click="searchText = ''; popupTab = '개'" :on="popupTab == '개'">개</element-tab-item>
              <element-tab-item @click="searchText = ''; popupTab = '고양이'" :on="popupTab == '고양이'">고양이</element-tab-item>
            </element-tab>
          </div>
        </div>
      </div>

      <div class="section-search">
        <div class="container">
          <template v-if="popupTab === '개'">
            <span v-for="item in searchDogText" @click="searchText = item" :class="[{ item: true }, { current: searchText == item }]">{{ item }}</span>
          </template>

          <template v-if="popupTab === '고양이'">
            <span v-for="item in searchCatText" @click="searchText = item" :class="[{ item: true }, { current: searchText == item }]">{{ item }}</span>
          </template>
        </div>
      </div>

      <div class="section-list">
        <div class="container">
          <template v-if="popupTab === '개'">
            <element-content-radio v-model="value" @checkPet="checkPet" :subLabel="value" :label="'품종'" :items="dogList.filter(o => o.keyword === searchText)" :requirement="false"/>
          </template>

          <template v-if="popupTab === '고양이'">
            <element-content-radio v-model="value" @checkPet="checkPet" :subLabel="value" :label="'품종'" :items="catList.filter(o => o.keyword === searchText)" :requirement="false"/>
          </template>
        </div>
      </div>


    </div>

    <div class="popup-bottom">
      <button @click="clickClose()">확인</button>
    </div>
    <slot />
  </div>
  </div>
</template>

<style lang="scss" scoped>
.popup-body {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.section-list {
    flex: 1;
    overflow: auto;
}
/*.element-popup{
  .close{
    width:2rem;
    height:2rem;
    background-image: url(/static/images/connection/close.png);
    background-size: 1.2*$unit;
    background-repeat: no-repeat;
    background-position: center right;
    font-size: 16px;
    font-weight: 600;
    position: absolute;
    right: 20px;
    top: 2rem;
    cursor: pointer;
  }
}*/
.section-search{
  display: block;
  padding: 10px;
  .container{
    display: block;
    &:After {
      clear: both;
      content: "";
      display: block;
    }
  }
  
  .item{
    float: left;
    padding: 12px;
    background-color: $color-schema-bright;
    border-radius: 3px;
    margin: 5px;

    &.current{
      background-color: $color-schema-dark;
      color: $color-white;
    }
  }
}
</style>

<script>
export default {
  props: [ "tab", "value", "data", "description", "statusPopup", "label", "subLabel", "subDescription" ],
  data(){
    return {
      status: this.statusPopup,
      popupTab: this.tab === '고양이' ? '고양이' : '개',

      searchText: '',

      searchDogText: [
        'ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ', 'ETC/믹스견'
      ],
      searchCatText: [
        'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ', 'ETC/믹스묘'
      ],

      selected: this.subLabel,
      dogList: [
        { label: "갈고 에스파뇨르", keyword: 'ㄱ' },
        { label: "가스콩 생통주아", keyword: 'ㄱ' },
        { label: "글렌 오브 이말 테리어", keyword: 'ㄱ' },
        { label: "골든 리트리버", keyword: 'ㄱ' },
        { label: "고든 세터", keyword: 'ㄱ' },
        { label: "그레이트 데인", keyword: 'ㄱ' },
        { label: "그레이트 피레니즈", keyword: 'ㄱ' },
        { label: "그레이터 스위스 마운틴 도그", keyword: 'ㄱ' },
        { label: "그릭 헤어하운드", keyword: 'ㄱ' },
        { label: "그린랜드 도그", keyword: 'ㄱ' },
        { label: "그레이하운드", keyword: 'ㄱ' },
        { label: "그리퐁 방뎅", keyword: 'ㄱ' },
        { label: "기주견", keyword: 'ㄱ' },
        { label: "골든 두들", keyword: 'ㄱ' },

        { label: "나폴리탄 마스티프(네오폴리탄 마스티프)", keyword: 'ㄴ' },
        { label: "뉴 기니아 싱잉 도그", keyword: 'ㄴ' },
        { label: "뉴펀들랜드", keyword: 'ㄴ' },
        { label: "노르보텐 스피츠", keyword: 'ㄴ' },
        { label: "노퍽 테리어", keyword: 'ㄴ' },
        { label: "노르웰지안 부훈트", keyword: 'ㄴ' },
        { label: "노르웨이 엘크 하운드", keyword: 'ㄴ' },
        { label: "노리치 테이러", keyword: 'ㄴ' },
        { label: "노바 스코셔 덕 톨링 리트리버", keyword: 'ㄴ' },

        { label: "닥스훈트", keyword: 'ㄷ' },
        { label: "달마시안", keyword: 'ㄷ' },
        { label: "댄디 딘몬트 테리어", keyword: 'ㄷ' },
        { label: "대니쉬 브로홀머(대니쉬 마스티프)", keyword: 'ㄷ' },
        { label: "도이치 브라케", keyword: 'ㄷ' },
        { label: "딩고", keyword: 'ㄷ' },
        { label: "도베르만(도베르만 핀셔)", keyword: 'ㄷ' },
        { label: "도고 아르젠티노", keyword: 'ㄷ' },
        { label: "도그 드 보르도", keyword: 'ㄷ' },
        { label: "동경견(동경이, 경주견, 경주개)", keyword: 'ㄷ' },
        { label: "도사견", keyword: 'ㄷ' },
        { label: "드렌체 파트리죤드", keyword: 'ㄷ' },
        { label: "드레버", keyword: 'ㄷ' },
        { label: "던커", keyword: 'ㄷ' },
        { label: "더치 세퍼드", keyword: 'ㄷ' },
        { label: "더치 스무숀드", keyword: 'ㄷ' },

        { label: "레브라도 리트리버", keyword: 'ㄹ' },
        { label: "레이크랜드 테리어", keyword: 'ㄹ' },
        { label: "랭카셔 힐러", keyword: 'ㄹ' },
        { label: "랜드시어", keyword: 'ㄹ' },
        { label: "랩핀포로코이라", keyword: 'ㄹ' },
        { label: "라프훈트", keyword: 'ㄹ' },
        { label: "라트비안 하운드", keyword: 'ㄹ' },
        { label: "레온베르거", keyword: 'ㄹ' },
        { label: "르베스크", keyword: 'ㄹ' },
        { label: "라사압소", keyword: 'ㄹ' },
        { label: "리트아니안 하운드", keyword: 'ㄹ' },
        { label: "로첸", keyword: 'ㄹ' },
        { label: "룬데훈트", keyword: 'ㄹ' },
        { label: "라페이로 도 알렌테조 (포루투기스 마스티프)", keyword: 'ㄹ' },
        { label: "레드본 쿤하운드", keyword: 'ㄹ' },
        { label: "로디지아 리지백", keyword: 'ㄹ' },
        { label: "로트와일러", keyword: 'ㄹ' },
        { label: "러시안 할리퀸 하운드", keyword: 'ㄹ' },
        { label: "라시안 하운드", keyword: 'ㄹ' },
        { label: "러시안 스파네일", keyword: 'ㄹ' },
        { label: "러시안 토이(러시안 토이 테리어", keyword: 'ㄹ' },
        { label: "라고토 로마그놀로", keyword: 'ㄹ' },
        { label: "랫 테리어", keyword: 'ㄹ' },

        { label: "마쟈르 아가르", keyword: 'ㅁ' },
        { label: "말티즈(몰티즈)", keyword: 'ㅁ' },
        { label: "말티푸", keyword: 'ㅁ' },
        { label: "맨체스터 테리어", keyword: 'ㅁ' },
        { label: "마렘마 쉽독", keyword: 'ㅁ' },
        { label: "마르키쉬에", keyword: 'ㅁ' },
        { label: "마스티프", keyword: 'ㅁ' },
        { label: "미디엄 푸들", keyword: 'ㅁ' },
        { label: "미들 아시안 오브차카", keyword: 'ㅁ' },
        { label: "미니어처 불 테리어", keyword: 'ㅁ' },
        { label: "미니어처 닥스훈트", keyword: 'ㅁ' },
        { label: "미니어처 핀셔", keyword: 'ㅁ' },
        { label: "미니어쳐 푸들", keyword: 'ㅁ' },
        { label: "미니어처 슈나우저", keyword: 'ㅁ' },

        { label: "발리 마운틴 도그 (킨타마니)", keyword: 'ㅂ' },
        { label: "바베트", keyword: 'ㅂ' },
        { label: "바센지", keyword: 'ㅂ' },
        { label: "바셋 아르테지안 노르만", keyword: 'ㅂ' },
        { label: "바셋 하운드", keyword: 'ㅂ' },
        { label: "바바리안 마운틴 하운드", keyword: 'ㅂ' },
        { label: "비글", keyword: 'ㅂ' },
        { label: "비글 해리어", keyword: 'ㅂ' },
        { label: "비어디드 콜리", keyword: 'ㅂ' },
        { label: "보스롱 (베르제 드 보스)", keyword: 'ㅂ' },
        { label: "베들링턴 테리어", keyword: 'ㅂ' },
        { label: "벨지안 그리퐁", keyword: 'ㅂ' },
        { label: "벨기에 말리노이즈", keyword: 'ㅂ' },
        { label: "벨기에 쉽독", keyword: 'ㅂ' },
        { label: "벨기에 테뷰런", keyword: 'ㅂ' },
        { label: "벨가마스코", keyword: 'ㅂ' },
        { label: "베르제 드 피카르", keyword: 'ㅂ' },
        { label: "베르제 드 피레네즈", keyword: 'ㅂ' },
        { label: "버니즈 마운틴 도그", keyword: 'ㅂ' },
        { label: "비숑 프리제", keyword: 'ㅂ' },
        { label: "빌리", keyword: 'ㅂ' },
        { label: "블랙 앤드 탄 쿤하운드", keyword: 'ㅂ' },
        { label: "블랙 러시안 테리어", keyword: 'ㅂ' },
        { label: "블루 드 가스코뉴", keyword: 'ㅂ' },
        { label: "블러드 하운드", keyword: 'ㅂ' },
        { label: "블루틱 쿤하운드", keyword: 'ㅂ' },
        { label: "보어보엘 (보볼, 남아프리카 마스티프)", keyword: 'ㅂ' },
        { label: "볼르그네제", keyword: 'ㅂ' },
        { label: "보더 콜리", keyword: 'ㅂ' },
        { label: "보더 테리어", keyword: 'ㅂ' },
        { label: "보르조이", keyword: 'ㅂ' },
        { label: "보스턴 테리어", keyword: 'ㅂ' },
        { label: "부비에 데 플랑드르", keyword: 'ㅂ' },
        { label: "복서", keyword: 'ㅂ' },
        { label: "보이킨 스파니엘", keyword: 'ㅂ' },
        { label: "브라꼬 이탈리아노", keyword: 'ㅂ' },
        { label: "브라크 다 리에쥐", keyword: 'ㅂ' },
        { label: "브라크 다 베르뉴", keyword: 'ㅂ' },
        { label: "브라크 뒤 부르보네", keyword: 'ㅂ' },
        { label: "브라크 뒤퓌이 (브라크 프랑세)", keyword: 'ㅂ' },
        { label: "브라크 생 제르맹", keyword: 'ㅂ' },
        { label: "브리아드", keyword: 'ㅂ' },
        { label: "브리타니 (브리타니 스파니엘)", keyword: 'ㅂ' },
        { label: "브뤼셀 그리핀", keyword: 'ㅂ' },
        { label: "불 테리어", keyword: 'ㅂ' },
        { label: "불독", keyword: 'ㅂ' },
        { label: "불 마스티프", keyword: 'ㅂ' },
        { label: "바스코타 스펫츠 (스위디시 발훈트)", keyword: 'ㅂ' },
        { label: "비즐라", keyword: 'ㅂ' },
        { label: "볼피노 이탈리아노", keyword: 'ㅂ' },


        { label: "시영 프랑세즈", keyword: 'ㅅ' },
        { label: "샤페이 (차이니즈 샤페이)", keyword: 'ㅅ' },
        { label: "시르네코 델레트나", keyword: 'ㅅ' },
        { label: "사르로스울프 하운드", keyword: 'ㅅ' },
        { label: "사부에소 에소파뇰", keyword: 'ㅅ' },
        { label: "세인트 버나드", keyword: 'ㅅ' },
        { label: "살루키", keyword: 'ㅅ' },
        { label: "사모예드", keyword: 'ㅅ' },
        { label: "삽살개", keyword: 'ㅅ' },
        { label: "사플라니낙", keyword: 'ㅅ' },
        { label: "삭펜도스", keyword: 'ㅅ' },
        { label: "스첼스퇴바레", keyword: 'ㅅ' },
        { label: "스키퍼키", keyword: 'ㅅ' },
        { label: "스코티시 디어하운드", keyword: 'ㅅ' },
        { label: "소크티시 테리어", keyword: 'ㅅ' },
        { label: "실리엄 테리어", keyword: 'ㅅ' },
        { label: "세구지오 이탈리아노", keyword: 'ㅅ' },
        { label: "셰터", keyword: 'ㅅ' },
        { label: "셔틀랜드 쉽독", keyword: 'ㅅ' },
        { label: "시바 이누", keyword: 'ㅅ' },
        { label: "시추", keyword: 'ㅅ' },
        { label: "시코쿠 (시꼬꾸)", keyword: 'ㅅ' },
        { label: "시베리안 허스키 (시베리언 허스키)", keyword: 'ㅅ' },
        { label: "시베리안 라이카", keyword: 'ㅅ' },
        { label: "실키 테리어", keyword: 'ㅅ' },
        { label: "스카이 테리어", keyword: 'ㅅ' },
        { label: "슬루기", keyword: 'ㅅ' },
        { label: "슬로바크 쿠바", keyword: 'ㅅ' },
        { label: "슬로바키안 하운드", keyword: 'ㅅ' },
        { label: "소프트 코티드 휘튼 테리어", keyword: 'ㅅ' },
        { label: "사우스 러시안 오브차카", keyword: 'ㅅ' },
        { label: "스페니쉬 마스티프", keyword: 'ㅅ' },
        { label: "스페니쉬 포인터", keyword: 'ㅅ' },
        { label: "스피노네 이탈리아노", keyword: 'ㅅ' },
        { label: "스피츠", keyword: 'ㅅ' },
        { label: "스테비 훈", keyword: 'ㅅ' },
        { label: "스테포드셔 불 테리어", keyword: 'ㅅ' },
        { label: "스테퍼드셔 불 테리어", keyword: 'ㅅ' },
        { label: "스탠다드 푸들", keyword: 'ㅅ' },
        { label: "스탠다드 슈나우져", keyword: 'ㅅ' },
        { label: "스티첼할", keyword: 'ㅅ' },
        { label: "스트렐루프스퇴바레", keyword: 'ㅅ' },
        { label: "스틸리안 마운틴 하운드", keyword: 'ㅅ' },
        { label: "서섹스 스파니엘", keyword: 'ㅅ' },
        { label: "스위스 하운드", keyword: 'ㅅ' },
        { label: "쇼로이츠퀸틀리", keyword: 'ㅅ' },
        { label: "스무스 콜리", keyword: 'ㅅ' },

        { label: "아펜핀셔", keyword: 'ㅇ' },
        { label: "아프칸 하운드", keyword: 'ㅇ' },
        { label: "에이디 (시앵 드 라틀라스)", keyword: 'ㅇ' },
        { label: "아이누견", keyword: 'ㅇ' },
        { label: "에어데일 테리어", keyword: 'ㅇ' },
        { label: "아크바시 도그", keyword: 'ㅇ' },
        { label: "아키타", keyword: 'ㅇ' },
        { label: "알래스칸 클리카이", keyword: 'ㅇ' },
        { label: "알래스칸 말라뮤트", keyword: 'ㅇ' },
        { label: "알핀 닥스브라케", keyword: 'ㅇ' },
        { label: "아메리칸 블랙 앤 쿤하운드", keyword: 'ㅇ' },
        { label: "아메리칸 불독", keyword: 'ㅇ' },
        { label: "아메리칸 불리 (불리)", keyword: 'ㅇ' },
        { label: "에스키모 도그 (아메리칸 에스키모 도그)", keyword: 'ㅇ' },
        { label: "아메리칸 폭스하운드", keyword: 'ㅇ' },
        { label: "아메리칸 핏 불 테리어", keyword: 'ㅇ' },
        { label: "아메리칸 스테포드셔 테리어", keyword: 'ㅇ' },
        { label: "아메리칸 워터 스파니엘", keyword: 'ㅇ' },
        { label: "아나톨리아 셰퍼드 도그 (아나톨리안 카바라시 도그)", keyword: 'ㅇ' },
        { label: "앨글로 프랑세즈", keyword: 'ㅇ' },
        { label: "아펜젤러", keyword: 'ㅇ' },
        { label: "아리에쥬아", keyword: 'ㅇ' },
        { label: "아르투아 하운드 (시엥 다르투아)", keyword: 'ㅇ' },
        { label: "오스트레일리언 캐틀 도그", keyword: 'ㅇ' },
        { label: "오스트레일리언 켈피", keyword: 'ㅇ' },
        { label: "오스트레일리언 셰퍼드", keyword: 'ㅇ' },
        { label: "오스트레일리언 테리어", keyword: 'ㅇ' },
        { label: "오스트리아 브랜들브라케", keyword: 'ㅇ' },
        { label: "오스트리아 숏트헤어드 핀셔", keyword: 'ㅇ' },
        { label: "아자와크", keyword: 'ㅇ' },
        { label: "아메리칸 코카 스파니엘 (코커 스파니엘)", keyword: 'ㅇ' },
        { label: "이스트 러시안 코오싱 하운드", keyword: 'ㅇ' },
        { label: "엘크하운드", keyword: 'ㅇ' },
        { label: "잉글리시 코카 스파니엘 (잉글리쉬 코커 스파니엘)", keyword: 'ㅇ' },
        { label: "잉글리시 쿤하운드", keyword: 'ㅇ' },
        { label: "잉글리시 폭스하운드", keyword: 'ㅇ' },
        { label: "잉글리시 포인터", keyword: 'ㅇ' },
        { label: "잉글리시 셰터", keyword: 'ㅇ' },
        { label: "잉글리시 셰퍼드", keyword: 'ㅇ' },
        { label: "잉글리시 스프링어 스파니엘", keyword: 'ㅇ' },
        { label: "잉글리시 토이 스파니엘", keyword: 'ㅇ' },
        { label: "엔텔부쳐", keyword: 'ㅇ' },
        { label: "에피뉴엘 프랑세", keyword: 'ㅇ' },
        { label: "에피뉴엘 파카르디", keyword: 'ㅇ' },
        { label: "에피뉴엘 퐁 오드메", keyword: 'ㅇ' },
        { label: "에스토니아 하운드", keyword: 'ㅇ' },
        { label: "에스트렐라 마운틴 도그", keyword: 'ㅇ' },
        { label: "유라시안", keyword: 'ㅇ' },
        { label: "이비전 하운드", keyword: 'ㅇ' },
        { label: "아이슬란드 도그", keyword: 'ㅇ' },
        { label: "잉카 헤어리스 도그 (페루비안 잉카 오키드)", keyword: 'ㅇ' },
        { label: "아이리시 레드 앤 화이트 세터", keyword: 'ㅇ' },
        { label: "아이리시 세터", keyword: 'ㅇ' },
        { label: "아이리시 테리어", keyword: 'ㅇ' },
        { label: "아이리시 워터 스파니엘", keyword: 'ㅇ' },
        { label: "아이리시 울프 하운드", keyword: 'ㅇ' },
        { label: "이탤리언 그레이하운드", keyword: 'ㅇ' },
        { label: "올드 데니쉬 버드 도그", keyword: 'ㅇ' },
        { label: "올드 잉글리쉬 쉽독", keyword: 'ㅇ' },
        { label: "올드 잉글리쉬 불독", keyword: 'ㅇ' },
        { label: "오터 하운드", keyword: 'ㅇ' },
        { label: "오우짜렉 포드할안스키", keyword: 'ㅇ' },
        { label: "웰시 코기 (펨브록 웰시 코기)", keyword: 'ㅇ' },
        { label: "와니머라너", keyword: 'ㅇ' },
        { label: "웰시 스프링어 스파니엘", keyword: 'ㅇ' },
        { label: "웰시 테리어", keyword: 'ㅇ' },
        { label: "웨스트 하이랜드 화이트 테리어", keyword: 'ㅇ' },
        { label: "웨스트팔라안 닥스브라케", keyword: 'ㅇ' },
        { label: "웨터훈", keyword: 'ㅇ' },
        { label: "와이어헤어드 포인팅 그리펀", keyword: 'ㅇ' },
        { label: "요크셔 테리어", keyword: 'ㅇ' },
        { label: "유고슬라비안 하운드", keyword: 'ㅇ' },
        { label: "아이리시 잭 러셀 테리어", keyword: 'ㅇ' },

        { label: "저먼 스파니엘 (도이체르 바흐텔훈트)", keyword: 'ㅈ' },
        { label: "저먼 헌트 테리어", keyword: 'ㅈ' },
        { label: "저먼 롱헤어드 포인터", keyword: 'ㅈ' },
        { label: "저먼 핀셔", keyword: 'ㅈ' },
        { label: "저먼 포인터", keyword: 'ㅈ' },
        { label: "저먼 셰퍼드 도그", keyword: 'ㅈ' },
        { label: "저면 쇼트페어드 포인터", keyword: 'ㅈ' },
        { label: "저먼 스피츠", keyword: 'ㅈ' },
        { label: "저먼 와이어헤어드 포인터", keyword: 'ㅈ' },
        { label: "자이언트 슈나우저", keyword: 'ㅈ' },
        { label: "잭 러셀 테리어", keyword: 'ㅈ' },
        { label: "제페니즈 친", keyword: 'ㅈ' },
        { label: "제페니즈 미들 사이즈 도그", keyword: 'ㅈ' },
        { label: "제피니즈 스피츠", keyword: 'ㅈ' },
        { label: "진돗개", keyword: 'ㅈ' },
        { label: "장모 치와와", keyword: 'ㅈ' },

        { label: "체스키 포섹", keyword: 'ㅊ' },
        { label: "체서피크 베이 리트리버", keyword: 'ㅊ' },
        { label: "치와와", keyword: 'ㅊ' },
        { label: "차이니스 크레스티드", keyword: 'ㅊ' },
        { label: "차우차우", keyword: 'ㅊ' },
        { label: "체코슬로바키안 울프독 (체코울프독)", keyword: 'ㅊ' },
        { label: "체스키 테리어", keyword: 'ㅊ' },

        { label: "케언 테리어", keyword: 'ㅋ' },
        { label: "케이넌 도그", keyword: 'ㅋ' },
        { label: "카네 코르소 (케인 코르소)", keyword: 'ㅋ' },
        { label: "카오 다 세라 데 아이레스", keyword: 'ㅋ' },
        { label: "카오 데 카스트로 라보레이로", keyword: 'ㅋ' },
        { label: "카디건 웰시 코기", keyword: 'ㅋ' },
        { label: "카탈란 쉽독", keyword: 'ㅋ' },
        { label: "코카시안 오프차카", keyword: 'ㅋ' },
        { label: "카발리에 킹 찰스 스파니엘", keyword: 'ㅋ' },
        { label: "클럼버 스파니엘", keyword: 'ㅋ' },
        { label: "콜리", keyword: 'ㅋ' },
        { label: "크로아티안 쉽독", keyword: 'ㅋ' },
        { label: "컬리코티드 리트리버", keyword: 'ㅋ' },
        { label: "카이견", keyword: 'ㅋ' },
        { label: "캉갈 도그 (캉갈)", keyword: 'ㅋ' },
        { label: "카레리언 베어 라이카", keyword: 'ㅋ' },
        { label: "카렐로-피니쉬 라이카", keyword: 'ㅋ' },
        { label: "케이스혼트", keyword: 'ㅋ' },
        { label: "케리 블루 테리어", keyword: 'ㅋ' },
        { label: "코몬도르", keyword: 'ㅋ' },
        { label: "쿠이거혼제", keyword: 'ㅋ' },
        { label: "크라스키 오브카", keyword: 'ㅋ' },
        { label: "크롬포흘뢴더", keyword: 'ㅋ' },
        { label: "쿠바스", keyword: 'ㅋ' },
        { label: "케니스 팬더", keyword: 'ㅋ' },

        { label: "텔로미언", keyword: 'ㅌ' },
        { label: "티베티안 마스티프 (티베탄 마스티프)", keyword: 'ㅌ' },
        { label: "티베탄 스파니엘", keyword: 'ㅌ' },
        { label: "티베탄 테리어", keyword: 'ㅌ' },
        { label: "토이 폭스 테리어", keyword: 'ㅌ' },
        { label: "토이 맨채스터 테리어", keyword: 'ㅌ' },
        { label: "토이 푸들", keyword: 'ㅌ' },
        { label: "트랜실바니안 하운드", keyword: 'ㅌ' },
        { label: "트링 워커 쿤하운드", keyword: 'ㅌ' },
        { label: "티롤러 브라케", keyword: 'ㅌ' },

        { label: "파피용 (콘티넨탈 토이 스파니엘)", keyword: 'ㅍ' },
        { label: "포브 드 브르타뉴", keyword: 'ㅍ' },
        { label: "필드 스파니엘", keyword: 'ㅍ' },
        { label: "필라 브라질레이로", keyword: 'ㅍ' },
        { label: "피니쉬 하운드", keyword: 'ㅍ' },
        { label: "피니시 스피츠", keyword: 'ㅍ' },
        { label: "플랫코티드 리트리버", keyword: 'ㅍ' },
        { label: "폭스 테리어 (스무드)", keyword: 'ㅍ' },
        { label: "폭스 테리어 (와이어)", keyword: 'ㅍ' },
        { label: "프렌치 불독", keyword: 'ㅍ' },
        { label: "페키니즈", keyword: 'ㅍ' },
        { label: "프티 바세 그리퐁 방댕", keyword: 'ㅍ' },
        { label: "프티 브라반숑", keyword: 'ㅍ' },
        { label: "파라오 하운드", keyword: 'ㅍ' },
        { label: "플롯 하운드", keyword: 'ㅍ' },
        { label: "포인터", keyword: 'ㅍ' },
        { label: "프와트뱅", keyword: 'ㅍ' },
        { label: "폴리쉬 그레이 하운드", keyword: 'ㅍ' },
        { label: "폴리쉬 하운드", keyword: 'ㅍ' },
        { label: "폴리시 롤런드 쉽독", keyword: 'ㅍ' },
        { label: "포메라니안", keyword: 'ㅍ' },
        { label: "폼피츠", keyword: 'ㅍ' },
        { label: "폼스키", keyword: 'ㅍ' },
        { label: "포르셀엔", keyword: 'ㅍ' },
        { label: "포르투갈 워터 도그", keyword: 'ㅍ' },
        { label: "푸델 포인터", keyword: 'ㅍ' },
        { label: "퍼그", keyword: 'ㅍ' },
        { label: "풀리", keyword: 'ㅍ' },
        { label: "푸미", keyword: 'ㅍ' },
        { label: "피레니안 마스티프", keyword: 'ㅍ' },
        { label: "파슨 러셀 테리어", keyword: 'ㅍ' },

        { label: "호르타이", keyword: 'ㅎ' },
        { label: "할델스퇴바레", keyword: 'ㅎ' },
        { label: "해밀톤스퇴바레", keyword: 'ㅎ' },
        { label: "해리어", keyword: 'ㅎ' },
        { label: "허배너스", keyword: 'ㅎ' },
        { label: "훗카이도 (호카이도)", keyword: 'ㅎ' },
        { label: "호바와트", keyword: 'ㅎ' },
        { label: "하이젠훈트", keyword: 'ㅎ' },
        { label: "휘핏", keyword: 'ㅎ' },
        { label: "화이트 셰퍼드 도그", keyword: 'ㅎ' },

        { label: "기타/믹스견 (5kg 이하)", keyword: 'ETC/믹스견' },
        { label: "기타/믹스견 (5kg 초과 15kg 이하)", keyword: 'ETC/믹스견' },
        { label: "기타/믹스견 (15kg 초과 25kg 이하)", keyword: 'ETC/믹스견' },
        { label: "기타/믹스견 (25kg 초과 35kg 이하)", keyword: 'ETC/믹스견' },
        { label: "기타/믹스견 (35kg 초과)", keyword: 'ETC/믹스견' },
      ],

      catList: [
        { label: "네벨룽", keyword: 'ㄴ' },
        { label: "노르웨이 숲", keyword: 'ㄴ' },

        { label: "데본렉스", keyword: 'ㄷ' },
        { label: "돈스코이", keyword: 'ㄷ' },

        { label: "라가 머핀", keyword: 'ㄹ' },
        { label: "라이코이", keyword: 'ㄹ' },
        { label: "라팜(라펌)", keyword: 'ㄹ' },
        { label: "라팜(라펌) 숏헤어", keyword: 'ㄹ' },
        { label: "랙돌(래그돌)", keyword: 'ㄹ' },
        { label: "러시안 블루", keyword: 'ㄹ' },

        { label: "맹크스", keyword: 'ㅁ' },
        { label: "먼치킨", keyword: 'ㅁ' },
        { label: "먼치킨 롱헤어", keyword: 'ㅁ' },
        { label: "메인 쿤", keyword: 'ㅁ' },
        { label: "메인 쿤 폴리델틱", keyword: 'ㅁ' },
        { label: "미뉴에트", keyword: 'ㅁ' },
        { label: "미뉴에트 롱헤어", keyword: 'ㅁ' },

        { label: "발리니즈", keyword: 'ㅂ' },
        { label: "버만", keyword: 'ㅂ' },
        { label: "버미즈 (버마 고양이)", keyword: 'ㅂ' },
        { label: "버밀라", keyword: 'ㅂ' },
        { label: "버밀라 롱헤어", keyword: 'ㅂ' },
        { label: "벵갈", keyword: 'ㅂ' },
        { label: "벵갈 롱헤어", keyword: 'ㅂ' },
        { label: "봄베이", keyword: 'ㅂ' },
        { label: "브리티쉬 롱헤어", keyword: 'ㅂ' },
        { label: "브리티쉬 숏헤어", keyword: 'ㅂ' },

        { label: "사바나 캣", keyword: 'ㅅ' },
        { label: "샤트룩스", keyword: 'ㅅ' },
        { label: "샴 (샤미즈)", keyword: 'ㅅ' },
        { label: "세렝게티", keyword: 'ㅅ' },
        { label: "셀커크 렉스", keyword: 'ㅅ' },
        { label: "셀커크 렉스 롱헤어", keyword: 'ㅅ' },
        { label: "소말리", keyword: 'ㅅ' },
        { label: "스노우 슈", keyword: 'ㅅ' },
        { label: "스코티쉬 스트레이트 롱헤어", keyword: 'ㅅ' },
        { label: "스코티쉬 스트레이트", keyword: 'ㅅ' },
        { label: "스코티쉬 폴드", keyword: 'ㅅ' },
        { label: "스코티쉬 폴드 롱헤어", keyword: 'ㅅ' },
        { label: "스핑크스", keyword: 'ㅅ' },
        { label: "시베리안", keyword: 'ㅅ' },
        { label: "싱가푸라", keyword: 'ㅅ' },


        { label: "아메리칸 밥 테일", keyword: 'ㅇ' },
        { label: "아메리칸 밥 테일 숏헤어", keyword: 'ㅇ' },
        { label: "아메리칸 숏헤어", keyword: 'ㅇ' },
        { label: "아메리칸 와이어헤어", keyword: 'ㅇ' },
        { label: "아메리칸 컬", keyword: 'ㅇ' },
        { label: "아메리칸 컬 롱헤어", keyword: 'ㅇ' },
        { label: "아비니시안", keyword: 'ㅇ' },
        { label: "엑조틱", keyword: 'ㅇ' },
        { label: "오리엔탈", keyword: 'ㅇ' },
        { label: "오리엔탈 롱헤어", keyword: 'ㅇ' },
        { label: "오스트레일리안 미스트", keyword: 'ㅇ' },
        { label: "오시캣", keyword: 'ㅇ' },
        { label: "요크 초콜릿", keyword: 'ㅇ' },
        { label: "유러피안 버미즈", keyword: 'ㅇ' },
        { label: "이집션 마우", keyword: 'ㅇ' },

        { label: "자바니즈", keyword: "ㅈ" },
        { label: "재피니즈 밥 테일", keyword: "ㅈ" },
        { label: "재피니즈 밥 테일 롱헤어", keyword: "ㅈ" },

        { label: "차이니스 리 와우", keyword: 'ㅊ' },
        { label: "쵸시", keyword: "ㅊ" },

        { label: "카오마니", keyword: "ㅋ" },
        { label: "캘리포니아 스팽글드", keyword: "ㅋ" },
        { label: "컬러포인트 숏헤어", keyword: "ㅋ" },
        { label: "코시니 렉스", keyword: "ㅋ" },
        { label: "코라트 (코랫)", keyword: "ㅋ" },
        { label: "코리안 숏헤어", keyword: "ㅋ" },
        { label: "쿠릴리안 밥 테일", keyword: "ㅋ" },
        { label: "쿠릴리안 밥 테일 롱헤어", keyword: "ㅋ" },
        { label: "킴릭", keyword: "ㅋ" },

        { label: "타이", keyword: 'ㅌ' },
        { label: "터키시 반", keyword: 'ㅌ' },
        { label: "터키시(터키쉬) 앙고라", keyword: 'ㅌ' },
        { label: "토이거", keyword: 'ㅌ' },
        { label: "통키니즈", keyword: 'ㅌ' },
        { label: "티파니", keyword: 'ㅌ' },

        { label: "페르시안", keyword: "ㅍ" },
        { label: "피터볼드", keyword: "ㅍ" },
        { label: "픽시밥", keyword: "ㅍ" },
        { label: "픽시밥 롱헤어", keyword: "ㅍ" },

        { label: "하나바 브라운", keyword: 'ㅎ' },
        { label: "하이랜더", keyword: 'ㅎ' },
        { label: "하이랜더 숏헤어", keyword: 'ㅎ' },
        { label: "히말라얀", keyword: 'ㅎ' },

        { label: "기타/믹스 고양이", keyword: 'ETC/믹스묘' }
      ]
    }
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        if(!!this.subDescription){
          value = this.popupHeaderTab;
        }
        this.$emit( "input", value );
      }
    }
  },
  created () {
    this.$store.commit( "SET_DIMMER", true );
  },
  methods: {
    clickClose() {
      this.$store.commit( "SET_DIMMER", false );
      this.status = !this.status;
      this.$emit( 'status', this.status );
    },
    checkValue: function( value ){
      this.$emit( "checkPopup", value);
    },
    checkPet: function( value ){

      this.$emit( "checkPet", value);
    },
    submitQuestion() {
      alert("질문이 전송되었습니다.")
    }
  }
}
</script>
